import { render, staticRenderFns } from "./WarehouseReceiptsView.vue?vue&type=template&id=ec542a1c&scoped=true"
import script from "./WarehouseReceiptsView.vue?vue&type=script&lang=js"
export * from "./WarehouseReceiptsView.vue?vue&type=script&lang=js"
import style0 from "./WarehouseReceiptsView.vue?vue&type=style&index=0&id=ec542a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec542a1c",
  null
  
)

export default component.exports